import Layout from '../components/layout/Layout'
import { AdminDashboard } from '../components/admin'

const Admin = () => {
  return <AdminDashboard />
}

export default Admin
